import React, { ReactNode } from 'react';
import { Card as PrimeCard } from 'primereact/card';
import { classNames } from 'primereact/utils';

interface CardProps {
  title?: string;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  subTitle?: string;
}

export const Card: React.FC<CardProps> = ({
  title,
  subTitle,
  children,
  className = '',
  contentClassName = ''
}) => {
  const cardClassName = classNames(
    'border shadow-sm',
    className
  );

  const contentClass = classNames(
    'p-0', // 24px padding for content
    contentClassName
  );

  const header = title ? (
    <div className="px-6 py-4 border-b border-gray-200">
      <h3 className="text-lg font-semibold text-gray-800 m-0 mb-2">{title}</h3>
      {subTitle && <div className="text-sm text-gray-600 mt-1">{subTitle}</div>}
    </div>
  ) : null;

  return (
    <PrimeCard
      title={null} // We're using custom header
      className={cardClassName}
      style={{ 
        padding: 0,
        borderRadius: '8px' // Exact 8px border radius per style guide
      }}
      header={header}
    >
      <div className={contentClass}>
        {children}
      </div>
    </PrimeCard>
  );
};